import { render, staticRenderFns } from "./ForgotSuccess.vue?vue&type=template&id=06665a8e&scoped=true&"
import script from "./ForgotSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgotSuccess.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/home.scss?vue&type=style&index=0&id=06665a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06665a8e",
  null
  
)

export default component.exports